<script>
  import { browser } from '$app/environment';
  import { env } from '$env/dynamic/public';
  import { analyticsStore, PreferenceState } from '$lib/analytics/store';
  import { gaEventTracker } from '$lib/analytics/tracker';
  import { pageHydrated } from '$lib/stores/loadStatus';

  let enableGoogleAnalytics = $derived(env.PUBLIC_ENABLE_GA === 'true');

  $effect(() => {
    if ($pageHydrated && browser && enableGoogleAnalytics) {
      switch ($analyticsStore.isDisabled) {
        case PreferenceState.Yes:
          gaEventTracker.remove();
          break;
        case PreferenceState.No:
          gaEventTracker.initialize();
          break;
        case PreferenceState.Unknown:
          // Nothing to do here. Waiting for analytics store to initialize
          break;
        default:
          console.error('Invalid analytics preference state');
      }
    }
  });
</script>
